module.exports = __webpack_public_path__ + "static/media/light-moderate.1c164dfe.png";